class NvSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.nv-slider__track');
    this.prev = this.querySelector('[data-nv-prev]');
    this.next = this.querySelector('[data-nv-next]');
    this.dots = this.querySelector('[data-nv-dots]');
    if (!this.track) return;
    this.prev?.addEventListener('click', () => this.go(-1));
    this.next?.addEventListener('click', () => this.go(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.build());
    this.build();
  }
  get step() {
    if (this.hasAttribute('data-page')) {
      return this.track.clientWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
    }
    const slide = this.track.querySelector('.nv-slider__slide');
    if (!slide) return 0;
    return slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
  }
  get pages() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    return this.step ? Math.max(1, Math.ceil((max - 2) / this.step) + 1) : 1;
  }
  go(dir) {
    this.track.scrollBy({ left: dir * this.step, behavior: 'smooth' });
  }
  goTo(i) {
    this.track.scrollTo({ left: i * this.step, behavior: 'smooth' });
  }
  build() {
    if (this.dots) {
      this.dots.innerHTML = '';
      for (let i = 0; i < this.pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv-slider__dot';
        b.setAttribute('aria-label', `Slide ${i + 1}`);
        b.addEventListener('click', () => this.goTo(i));
        this.dots.appendChild(b);
      }
      this.dots.hidden = this.pages <= 1;
    }
    this.update();
  }
  update() {
    const max = this.track.scrollWidth - this.track.clientWidth - 1;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    const nav = this.querySelector('.nv-slider__nav');
    if (nav) nav.hidden = max <= 0;
    if (this.dots) {
      let current = this.step ? Math.round(this.track.scrollLeft / this.step) : 0;
      if (max > 0 && this.track.scrollLeft >= max - 1) current = this.pages - 1;
      [...this.dots.children].forEach((d, i) => d.setAttribute('aria-current', i === current ? 'true' : 'false'));
    }
  }
}
if (!customElements.get('nv-slider')) customElements.define('nv-slider', NvSlider);

/* Gallery thumbnails: sharper files for hi-dpi phones. (The big gallery images get their size steps, priority and lazy loading
   straight from the product hero section, so they are not touched here.) */
(() => {
  const sharpen = () => {
    document.querySelectorAll('.nv-gallery__thumb img').forEach((img) => {
      const s = img.getAttribute('src') || '';
      if (/width=\d+/.test(s)) {
        img.setAttribute('srcset', [120, 240, 360].map((w) => s.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w').join(', '));
        img.setAttribute('sizes', '56px');
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sharpen); else sharpen();
})();

/* Shared helpers for the Kaching bundle block */
const nvBundleBars = () => [...document.querySelectorAll('.nv-app-offer .kaching-bundles__bar')].filter((b) => !b.closest('.kaching-bundles__subscriptions'));
const nvSelectedBundle = () => nvBundleBars().findIndex((b) => b.classList.contains('kaching-bundles__bar--selected'));
const nvPickBar = (i) => { const b = nvBundleBars()[i]; if (b) (b.querySelector('input[type="radio"], [role="radio"]') || b).click(); };
/* The delivery schedule dropdown's value is the customer's choice; Kaching can reset the form's own plan field, so read from here first */
const nvChosenPlan = (fallback) => { const dd = document.querySelector('.nv-plan:not([hidden]) .nv-plan__select'); return dd && dd.value ? dd.value : fallback; };

/* While the bundle block is being set up, show a soft placeholder in its place (the block itself stays invisible so Kaching's
   own bottle dropdowns and the setup below never flash on screen). It is released as soon as the block is ready, or after a
   few seconds at the latest. */
const nvHold = (() => {
  let st = null;
  let timer = null;
  const release = () => { if (st) { st.remove(); st = null; } if (timer) { clearTimeout(timer); timer = null; } };
  if (document.querySelector('.nv-app-offer')) {
    st = document.createElement('style');
    st.textContent = '.nv-app-offer{position:relative;min-height:380px}.nv-app-offer>*{visibility:hidden}.nv-app-offer::before{content:"";position:absolute;inset:0;border-radius:16px;background:linear-gradient(100deg,#f4f3fb 30%,#e8e6f6 50%,#f4f3fb 70%);background-size:200% 100%;animation:nvsk 1.3s linear infinite}@keyframes nvsk{to{background-position:-200% 0}}.nv-variant,.kaching-bundles__bar-variants{display:none!important}';
    document.head.appendChild(st);
    timer = setTimeout(release, 7000);
  }
  return release;
})();

/* Pack variants: when the product has variants titled "Buy 1", "Buy 2", "Buy 3", each variant is ONE pack of that many
   bottles with the bundle price baked in (so checkout's recurring subtotal is right and the customer portal can switch
   packs safely). Each bundle bar adds quantity 1 of its own pack. Kaching shows a variant dropdown inside each bar; we
   set each bar's dropdown to its own pack the instant Kaching draws it (so the right prices are on screen from the first
   frame) and hide it. Kaching also shows its own delivery-plan dropdown inside the selected bar when Subscribe is on; we
   hide that too (the delivery schedule in the Subscribe card replaces it). Products without those variants are not
   affected. */
let nvVariants = null;
let nvPlans = [];
let nvLoading = null;
const nvLoadVariants = () => {
  if (nvLoading) return nvLoading;
  nvLoading = (async () => {
    nvVariants = {};
    try {
      const m = location.pathname.match(/\/products\/([^/?#]+)/);
      const data = await (await fetch('/products/' + m[1] + '.js')).json();
      data.variants.forEach((v) => { const n = (v.title || '').match(/^Buy\s+(\d+)$/i); if (n) nvVariants[parseInt(n[1], 10)] = v.id; });
      nvPlans = ((data.selling_plan_groups || [])[0] || {}).selling_plans || [];
    } catch (e) {}
    return nvVariants;
  })();
  return nvLoading;
};
/* Start fetching the product data right away; it is only needed for the cart logic, not for showing the bundle */
if (document.querySelector('.nv-app-offer') && /\/products\//.test(location.pathname)) nvLoadVariants();
(() => {
  const root = document.querySelector('.nv-app-offer');
  if (!root) return;
  const setSel = (s, v) => {
    Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set.call(s, v);
    s.dispatchEvent(new Event('input', { bubbles: true }));
    s.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const bottleSelects = (bar) => [...bar.querySelectorAll('select.kaching-bundles__bar-variant-select:not(.kaching-bundles__selling-plan-select)')];
  const hasPack = (s, n) => !![...s.options].find((o) => o.value === 'Buy ' + n);
  let hidden = false;
  let released = false;
  /* Runs on every change Kaching makes to the block, before the browser paints it */
  const tick = () => {
    const bars = nvBundleBars();
    if (bars.length < 2) return;
    const all = bars.map(bottleSelects);
    if (!all.some((s) => s.length)) {
      /* Kaching drew the bars without bottle dropdowns: this product has no pack variants, nothing to set up */
      if (!released) { released = true; requestAnimationFrame(nvHold); }
      return;
    }
    if (!hidden) {
      hidden = true;
      const st = document.createElement('style');
      st.textContent = '.nv-variant,.kaching-bundles__bar-variants,.nv-app-offer .kaching-bundles__bar-selling-plan{display:none!important}';
      document.head.appendChild(st);
    }
    let ready = true;
    bars.forEach((bar, i) => {
      const n = Math.min(i + 1, 3);
      all[i].forEach((s) => {
        if (!hasPack(s, n)) return;
        if (s.value !== 'Buy ' + n) { setSel(s, 'Buy ' + n); ready = false; }
      });
    });
    if (ready && !released) {
      released = true;
      requestAnimationFrame(() => requestAnimationFrame(nvHold));
    }
  };
  /* The cart form needs the id of the selected pack (waits for the product data, which does not hold up the display) */
  const syncForm = async () => {
    const map = await nvLoadVariants();
    const n = Object.keys(map).length;
    const form = document.getElementById('nv-product-form');
    if (!n || !form) return;
    const idx = Math.max(nvSelectedBundle(), 0);
    const id = map[Math.min(idx + 1, n)];
    const field = form.querySelector('[name="id"]');
    if (!id || !field || String(field.value) === String(id)) return;
    field.value = id;
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const onChange = () => { tick(); requestAnimationFrame(syncForm); };
  new MutationObserver(onChange).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  nvLoadVariants().then(syncForm);
  onChange();
})();

/* Delivery schedule: Kaching's subscription card has no frequency picker, so show the product's selling plans
   in a dropdown inside the Subscribe & Save card once it is ticked, and write the choice to the cart form's
   selling_plan field. The dropdown follows the bundle: 1 bottle = every month, 2 bottles = every 2 months,
   3 bottles = every 3 months (customers can still change it). Turn it off with the "Show delivery schedule" setting. */
(() => {
  let plans = null;
  const getPlans = async () => {
    if (plans) return plans;
    await nvLoadVariants();
    plans = nvPlans;
    return plans;
  };
  const label = (n) => String(n).replace(/^Delivery:\s*/i, '').replace(/\s*\|\s*/, ' · ').replace(/^./, (c) => c.toUpperCase());
  const apply = (id) => {
    document.querySelectorAll('input[name="selling_plan"]').forEach((i) => { if (i.value !== String(id)) { i.value = id; i.dispatchEvent(new Event('change', { bubbles: true })); } });
  };
  let chosen = null;
  let lastBundle = -2;
  const planFor = (list, bundle) => list[Math.max(0, Math.min(bundle < 0 ? 0 : bundle, list.length - 1))];
  const sync = async () => {
    const card = document.querySelector('.nv-app-offer .kaching-bundles__subscriptions');
    if (!card) return;
    const box = card.querySelector('[role="checkbox"]');
    const on = box && box.getAttribute('aria-checked') === 'true';
    const inner = card.querySelector('.kaching-bundles__bar-wrapper');
    if (!inner) return;
    let wrap = inner.querySelector('.nv-plan');
    if (!on) { if (wrap) wrap.hidden = true; return; }
    const list = await getPlans();
    if (list.length < 2) return;
    const bundle = nvSelectedBundle();
    const sameBundle = bundle === lastBundle;
    if (!sameBundle) { lastBundle = bundle; chosen = null; }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'nv-plan';
      wrap.innerHTML = '<span class="nv-plan__label">Delivery schedule</span><select class="nv-plan__select" aria-label="Delivery schedule"></select>';
      const sel = wrap.querySelector('select');
      list.forEach((p) => { const o = document.createElement('option'); o.value = p.id; o.textContent = label(p.name); sel.appendChild(o); });
      sel.addEventListener('change', () => { chosen = sel.value; apply(sel.value); });
      ['click', 'keydown', 'keyup', 'mousedown', 'touchstart'].forEach((ev) => wrap.addEventListener(ev, (e) => e.stopPropagation()));
      inner.appendChild(wrap);
    }
    const sel = wrap.querySelector('select');
    const want = chosen || String(planFor(list, bundle).id);
    if (sel.value !== want) sel.value = want;
    wrap.hidden = false;
    apply(sel.value);
  };
  const start = () => {
    const root = document.querySelector('.nv-app-offer');
    const buy = document.getElementById('nv-buy');
    if (!root || (buy && buy.dataset.deliverySchedule === 'false')) return;
    const st = document.createElement('style');
    st.textContent = '.nv-plan{display:flex;flex-wrap:wrap;align-items:center;gap:8px 12px;margin:12px 0 0;padding:12px 0 0 34px;border-top:1px solid rgba(86,79,175,.18);width:100%;box-sizing:border-box}.nv-plan[hidden]{display:none}.nv-plan__label{font-size:13px;font-weight:700;color:#0f0f0f}.nv-plan__select{flex:1;min-width:150px;padding:9px 10px;border-radius:10px;border:1px solid rgba(15,15,15,.18);background:#fff;font:inherit;font-size:14px;color:#0f0f0f}';
    document.head.appendChild(st);
    new MutationObserver(() => requestAnimationFrame(sync)).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(start, 300)); else setTimeout(start, 300);
})();

/* Most popular badge on the bundle bars. Set in the product section settings:
   - "Theme badge": the theme draws a pill on the chosen bundle and hides Kaching's own most-popular labels
   - "Kaching badge": the theme adds nothing and Kaching's own badge is shown
   - "None": no most-popular badge */
(() => {
  const apply = () => {
    const buy = document.getElementById('nv-buy');
    if (!buy) return;
    const mode = buy.dataset.popularMode || 'theme';
    const target = (parseInt(buy.dataset.popularBundle, 10) || 2) - 1;
    const text = buy.dataset.popularText || 'Most popular';
    const bars = nvBundleBars();
    bars.forEach((bar, i) => {
      const box = bar.querySelector('.kaching-bundles__bar-container') || bar;
      let pill = bar.querySelector('.nv-pop-badge');
      if (mode === 'theme' && i === target) {
        if (!pill) { pill = document.createElement('span'); pill.className = 'nv-pop-badge'; box.appendChild(pill); }
        if (pill.textContent !== text) pill.textContent = text;
      } else if (pill) pill.remove();
      bar.querySelectorAll('.kaching-bundles__bar-label').forEach((l) => {
        const popular = /most\s*popular/i.test(l.textContent);
        if (mode === 'theme' && popular) l.style.setProperty('display', 'none', 'important');
        else if (l.style.display === 'none') l.style.removeProperty('display');
      });
      bar.querySelectorAll('.kaching-bundles__bar-most-popular').forEach((m) => {
        if (mode === 'kaching') m.style.setProperty('display', 'block', 'important');
        else m.style.removeProperty('display');
      });
    });
  };
  const start = () => {
    const root = document.querySelector('.nv-app-offer');
    if (!root) return;
    const st = document.createElement('style');
    st.textContent = '.nv-app-offer .kaching-bundles__bar-container{position:relative;overflow:visible}.nv-pop-badge{position:absolute;top:-11px;right:18px;z-index:2;padding:4px 12px;border-radius:999px;background:linear-gradient(135deg,#564faf,#453f8c);color:#fff;font-size:11px;font-weight:800;letter-spacing:.06em;line-height:1.3;text-transform:uppercase;box-shadow:0 6px 14px rgba(86,79,175,.35);pointer-events:none}';
    document.head.appendChild(st);
    new MutationObserver(() => requestAnimationFrame(apply)).observe(root, { subtree: true, childList: true });
    apply();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(start, 300)); else setTimeout(start, 300);
})();

/* Add to cart button: always show the selected bundle's total and its compare-at price struck through
   ("Add to cart · $59.99  $99.98"). Kaching adds its own total only in some states, so when it is missing
   we add one from the selected bundle bar, and we remove ours as soon as Kaching's appears. */
(() => {
  const showPrices = () => {
    const btn = document.querySelector('#nv-buy .nv-hero__cta');
    if (!btn) return;
    const bar = document.querySelector('.nv-app-offer .kaching-bundles__bar--selected');
    const now = bar && bar.querySelector('.kaching-bundles__bar-price');
    const was = bar && bar.querySelector('.kaching-bundles__bar-full-price');
    const nowText = now ? now.textContent.trim() : '';
    const wasText = was ? was.textContent.trim() : '';
    let own = btn.querySelector('.nv-atc-now');
    let el = btn.querySelector('.nv-atc-was');
    const kaching = btn.querySelector('.kaching-bundles-atc-total');
    if (!nowText) { if (own) own.remove(); if (el) el.remove(); return; }
    let anchor = kaching;
    if (kaching) {
      if (own) own.remove();
    } else {
      if (!own) { own = document.createElement('span'); own.className = 'nv-atc-now'; btn.appendChild(own); }
      const t = ' · ' + nowText;
      if (own.textContent !== t) own.textContent = t;
      anchor = own;
    }
    if (!wasText) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('s'); el.className = 'nv-atc-was'; }
    if (el.textContent !== wasText) { el.textContent = wasText; el.setAttribute('aria-label', 'was ' + wasText); }
    if (el.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', el);
  };
  const start = () => {
    const btn = document.querySelector('#nv-buy .nv-hero__cta');
    const root = document.querySelector('.nv-app-offer');
    if (!btn || !root) return;
    const st = document.createElement('style');
    st.textContent = '.nv-atc-was{margin-left:8px;font-size:.82em;font-weight:500;opacity:.75;text-decoration-thickness:1.5px}';
    document.head.appendChild(st);
    const run = () => requestAnimationFrame(showPrices);
    new MutationObserver(run).observe(btn, { childList: true, subtree: true, characterData: true });
    new MutationObserver(run).observe(root, { childList: true, subtree: true, attributes: true, characterData: true });
    showPrices();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(start, 300)); else setTimeout(start, 300);
})();

/* Cart drawer stays in step with the real cart: when the browser restores this page from its cache (for example Back from
   checkout), the drawer and cart count would otherwise show the cart as it was when the page first loaded. */
(() => {
  const refresh = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.getSectionInnerHTML !== 'function') return;
    try {
      const list = drawer.getSectionsToRender();
      const res = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?sections=' + list.map((s) => s.id).join(','));
      const sec = await res.json();
      list.forEach((s) => {
        const el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (el && sec[s.id]) el.innerHTML = drawer.getSectionInnerHTML(sec[s.id], s.selector);
      });
      const c = await (await fetch('/cart.js')).json();
      drawer.classList.toggle('is-empty', c.item_count === 0);
    } catch (e) { /* leave the drawer as it is */ }
  };
  window.addEventListener('pageshow', (e) => {
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (e.persisted || (nav && nav.type === 'back_forward')) refresh();
  });
})();

/* One cart line per product. Products without pack variants: Kaching stamps every added line with a bundle ID, so adding
   2 bottles and then 1 more made two rows; when the same product (both one-time, or both subscribed) is already in the
   cart we add to that line and re-price it at the matching bundle tier. Products with pack variants (Buy 1 / 2 / 3):
   the bottles already in the cart plus the bottles being added decide the pack (up to 3 bottles); the cart line moves to
   that pack (quantity 1) and, for subscriptions, to the schedule for that pack (this does not depend on the bundle block
   on the page, so it works however slowly that loads). Beyond 3 bottles, or if anything unexpected happens, it falls
   back to a normal add. */
(() => {
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const sections = (drawer) => ({ sections: drawer.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname });
  const plainAdd = async (fd, drawer) => {
    const body = new FormData();
    for (const [k, v] of fd.entries()) body.append(k, v);
    const s = sections(drawer);
    body.append('sections', s.sections);
    body.append('sections_url', s.sections_url);
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
    return data;
  };
  const tierFor = async (form, idx) => {
    const cur = nvSelectedBundle();
    if (idx !== cur) { nvPickBar(idx); await wait(1200); }
    const fd = new FormData(form);
    const tier = { props: fd.get('properties[__kaching_bundles]'), plan: nvChosenPlan(fd.get('selling_plan')) };
    if (idx !== cur && cur >= 0) { nvPickBar(cur); await wait(400); }
    return tier;
  };
  const changeUrl = () => (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
  document.addEventListener('submit', async (e) => {
    const form = e.target && e.target.closest ? e.target.closest('#nv-product-form') : null;
    if (!form || !document.querySelector('.nv-app-offer .kaching-bundles__bar')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const drawer = document.querySelector('cart-drawer');
    const btn = form.querySelector('[type="submit"]');
    if (!drawer || typeof drawer.renderContents !== 'function' || (btn && btn.dataset.nvBusy)) return;
    if (btn) { btn.dataset.nvBusy = '1'; btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); form.querySelector('.loading__spinner')?.classList.remove('hidden'); }
    const done = () => { if (btn) { delete btn.dataset.nvBusy; btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); form.querySelector('.loading__spinner')?.classList.add('hidden'); } };
    const fd = new FormData(form);
    if (fd.get('selling_plan')) fd.set('selling_plan', nvChosenPlan(fd.get('selling_plan')));
    try {
      const variantId = parseInt(fd.get('id'), 10);
      const qty = parseInt(fd.get('quantity'), 10) || 1;
      const subscribed = !!fd.get('selling_plan');
      const map = await nvLoadVariants();
      const packs = Object.keys(map).length;
      const packOf = (vid) => { const k = Object.keys(map).find((n) => map[n] === vid); return k ? parseInt(k, 10) : 0; };
      const cart = await (await fetch('/cart.js')).json();
      let data;
      if (packs) {
        const existing = cart.items.find((i) => packOf(i.variant_id) && !!i.selling_plan_allocation === subscribed);
        const total = existing ? packOf(existing.variant_id) * existing.quantity + packOf(variantId) * qty : 0;
        if (existing && packOf(variantId) && total <= packs) {
          const item = { id: map[total], quantity: 1 };
          if (subscribed && nvPlans[total - 1]) item.selling_plan = nvPlans[total - 1].id;
          const addRes = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
          const addData = await addRes.json();
          if (!addRes.ok || addData.status) throw new Error(addData.description || addData.message || 'add failed');
          const s = sections(drawer);
          const res = await fetch(changeUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: existing.key, quantity: 0, sections: s.sections, sections_url: s.sections_url }) });
          data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'merge failed');
        } else {
          data = await plainAdd(fd, drawer);
        }
      } else {
        const existing = cart.items.find((i) => i.variant_id === variantId && !!i.selling_plan_allocation === subscribed && i.properties && i.properties.__kaching_bundles);
        if (existing && fd.get('properties[__kaching_bundles]')) {
          const total = existing.quantity + qty;
          const idx = Math.min(total, nvBundleBars().length || 3) - 1;
          const tier = await tierFor(form, idx);
          if (!tier.props) throw new Error('no bundle props');
          const s = sections(drawer);
          const payload = { id: existing.key, quantity: total, properties: { __kaching_bundles: tier.props }, sections: s.sections, sections_url: s.sections_url };
          if (subscribed && tier.plan) payload.selling_plan = tier.plan;
          const res = await fetch(changeUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'merge failed');
        } else {
          data = await plainAdd(fd, drawer);
        }
      }
      if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (err) {
      try {
        const data = await plainAdd(fd, drawer);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } catch (err2) {
        const box = form.closest('product-form');
        const msg = box && box.querySelector('.product-form__error-message');
        if (msg) { msg.textContent = err2.message || 'Could not add to cart.'; msg.closest('[role="alert"]')?.removeAttribute('hidden'); }
      }
    } finally {
      done();
    }
  }, true);
})();
